import { useEffect, useState } from 'react';
import olms from 'ol-mapbox-style';
import OLMap from 'ol/Map';
import OLView from 'ol/View';

const OLMSLayer = (props) => {
    const { zIndex, map, url, visible, title = '' } = props;
    const [lyr, setLayer] = useState(0);
    const [active, setActive] = useState(false);

    useEffect(async () => {
        if (!map && !active) return;
        setActive(true);
        const fpoObj = new OLMap({ view: new OLView() });

        olms(fpoObj, url).then(() => {
            const lyrFound = fpoObj.getLayers().array_[0];
            lyrFound.set('title', title);
            setLayer(lyrFound);
            fpoObj.removeLayer(lyrFound);
            map.addLayer(lyrFound);
        });
        return () => {
            if (map) {
                map.removeLayer(lyr);
            }
        };
    }, [map]);

    useEffect(() => {
        if (!map || !lyr) return;
        lyr.setOpacity(visible ? 1 : 0);
    }, [visible]);

    useEffect(() => {
        if (!lyr) return;
        lyr.setZIndex(zIndex);
    }, [lyr]);

    return null;
};
export { OLMSLayer };
